import { ContentsAction, ContentsActionType } from './Contents.action-types';
import { ContentsState } from './Contents.types';

export function contentsReducer(state: ContentsState = {}, action: ContentsAction): ContentsState {
  switch (action.type) {
    case ContentsActionType.REQUEST_VIEW_CONTENTS: {
      return {
        ...state,
        [action.viewId]: {
          ...state[action.viewId],
          isLoading: true,
        },
      };
    }
    case ContentsActionType.RECEIVE_VIEW_CONTENTS: {
      return {
        ...state,
        [action.viewId]: {
          ...state[action.viewId],
          isLoading: false,
          contents: action.contents,
        },
      };
    }
    default:
      return state;
  }
}
